import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
      staleTime: 1,
      cacheTime: 1,
    },
  },
  queryCache: new QueryCache({
    onSuccess: (data, query) => {
      // console.log('onSuccess: ', data, query);
    },
    onError: (error, query) => {
      // API 에러가 발생해도 웹사이트가 계속 동작하도록 에러를 로깅만 하고 넘어감
      console.warn('API Error (will continue):', {
        message: error?.message,
        status: error?.response?.status,
        url: error?.config?.url,
      });
      // 에러를 throw하지 않음으로써 앱이 멈추지 않도록 함
    },
  }),
  mutationCache: new MutationCache({
    onMutate: (variables, mutation) => {
      // console.log('onMutate: ', variables, mutation);
    },
    onSuccess: (data, variables, context, mutation) => {
      // console.log('onSuccess: ', data, variables);
    },
    onError: (error, variables, context, mutation) => {
      console.warn('Mutation Error (will continue):', {
        message: error?.message,
        status: error?.response?.status,
      });
    },
  }),
});

function QueryProvider({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

export default QueryProvider;
